import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { getAllWorkTypeAsync, getWorkTypeByIdAsync } from './workTypeThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const workTypeSlice = createSlice({
    name: 'workType',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllWorkTypeAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllWorkTypeAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.apiError = undefined;
            state.workTypes = action.payload;
            state.workTypeActiveHourTypesDropDown = action.payload.filter(workType => workType.active == true).map((workType) => {
                return {
                    label: `${workType.name}`,
                    value: workType.id,
                    number: workType.basePrice?.toString()
                };
            });
            state.workTypeAllHourTypesDropDown = action.payload.map((workType) => {
                return {
                    label: `${workType.name}`,
                    value: workType.id,
                    number: workType.basePrice?.toString()
                };
            });
        })
            .addCase(getAllWorkTypeAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getWorkTypeByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getWorkTypeByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.apiError = undefined;
            state.workType = action.payload;
        })
            .addCase(getWorkTypeByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default workTypeSlice.reducer;
